export const INITIAL_VALUES = {
  lastname: '',
  firstname: '',
  secondname: undefined,
  phone: '',
  phoneExt: undefined
}
